import gql from 'graphql-tag';

export const HierarchyItemForPasswordValidation = gql`
  query hierarchyItem($id: RecordID!) {
    hierarchyItem(id: $id, for_account_profile: true) {
      ... on IHierarchyItem {
        id
        item_type
      }
      ... on HierarchyAlbumFolderItem {
        album_folder {
          id
          root {
            id
          }
          account {
            id
            email_address
            logo_image {
              id
              url
            }
            pro_settings {
              non_stripe_connect_sell_photos_enabled
              photo_attribution_page {
                email_address
              }
            }
          }
        }
      }
      ... on HierarchyAlbumItem {
        album {
          id
          root_album_folder {
            id
          }
          creator {
            id
            email_address
            logo_image {
              id
              url
            }
            pro_settings {
              non_stripe_connect_sell_photos_enabled
              photo_attribution_page {
                email_address
              }
            }
          }
        }
      }
    }
  }
`;

export const HierarchyAuthTokenVerify = gql`
  query hierarchyAuthTokenVerify($token: String!) {
    hierarchyAuthTokenVerify(token: $token) {
      is_valid
    }
  }
`;
